"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.matchesErrorCode = exports.getErrorData = exports.isJourneyError = void 0;
const errors_1 = require("./errors");
const isJourneyError = (err) => {
    const matches = err instanceof errors_1.JourneyError || err.is_journey_error;
    return !!matches;
};
exports.isJourneyError = isJourneyError;
const getErrorData = (err) => {
    if (!(0, exports.isJourneyError)(err)) {
        return;
    }
    return err.toJSON();
};
exports.getErrorData = getErrorData;
const matchesErrorCode = (err, code) => {
    if ((0, exports.isJourneyError)(err)) {
        return err.errorData.code === code;
    }
    return false;
};
exports.matchesErrorCode = matchesErrorCode;
